export default __webpack_public_path__ + "static/media/43t.cfe37887.jpg";